
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"furtherActions":"Mehr ...","information":"Informationen","remove":"Entfernen","error":"Fehler"},"en":{"furtherActions":"More ...","information":"Information","remove":"Remove","error":"Error"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();